import React from 'react';
import ReactDOM from 'react-dom';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderLoadingSpinner = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<LoadingSpinner props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering LoadingSpinner:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};